export const SEARCH_RESPELLINGS: Record<string, string> = {
  'additional': 'traditional',
  'african': 'africa',
  'alcoholic': 'nonalcoholic',
  'america': 'american',
  'angelos': 'angels',
  'armenian': 'armenia',
  'artizan': 'artisan',
  'austria': 'australia',
  'bages': 'bags',
  'barbara': 'barbera',
  'bare foot': 'barefoot',
  'base': 'based',
  'beach': 'each',
  'beast': 'best',
  'beeer': 'beer',
  'bell': 'belle',
  'blanca': 'blanc',
  'blanco': 'blanc',
  'blast': 'last',
  'block': 'bock',
  'blood': 'bloody',
  'blue berry wine': 'blueberry wine',
  'bone': 'bonne',
  'bottled': 'bottles',
  'bourban': 'bourbon',
  'bourboun': 'bourbon',
  'branch': 'ranch',
  'breast': 'beast',
  'brewers': 'brewery',
  'bridge': 'ridge',
  'browne': 'brown',
  'buffallo trace': 'buffalo trace',
  'buttery': 'butter',
  'cabarnay': 'cabernet',
  'cabarnet': 'cabernet',
  'cabarnet sauvignon': 'cabernet sauvignon',
  'cabernay': 'cabernet',
  'caberney': 'cabernet',
  'camo': 'campo',
  'camp': 'campo',
  'canadian': 'canada',
  'candles': 'candies',
  'canon': 'canyon',
  'cantina': 'anthina',
  'cassis': 'classics',
  'chai': 'chair',
  'champaign': 'champagne',
  'champagn': 'champagne',
  'chardanay': 'chardonnay',
  'chardannay': 'chardonnay',
  'chardonay': 'chardonnay',
  'chardoney': 'chardonnay',
  'charmes': 'charles',
  'chelada': 'michelada',
  'chill': 'hill',
  'choco': 'choc',
  'choloate wine': 'chocolate wine',
  'cigaret': 'cigarette',
  'ciger': 'cigar',
  'ciggarette': 'cigarette',
  'clasico': 'classic',
  'classico': 'classic',
  'classics': 'cassis',
  'coars': 'coors',
  'coco': 'cocoa',
  'columbia': 'colombia',
  'coors': 'colors',
  'corrs': 'coors',
  'count': 'county',
  'country': 'county',
  'cracked': 'cracker',
  'creamery': 'creamy',
  'creamy': 'cream',
  'crest': 'rest',
  'crispy': 'crisp',
  'cristal': 'crystal',
  'crunch': 'crunchy',
  'cutter': 'cutwater',
  'dark horse': 'darkhorse',
  'desert': 'dessert',
  'diner': 'dinner',
  'distillers': 'distillery',
  'earl': 'pearl',
  'especial': 'special',
  'estrella': 'stella',
  'expresso': 'espresso',
  'fashion': 'fashioned',
  'finished': 'finish',
  'flavor': 'flavored',
  'flight': 'light',
  'fluted': 'flute',
  'forester': 'forest',
  'franc': 'france',
  'frontera': 'frontier',
  'frosted': 'roasted',
  'gallon': 'gallo',
  'georgian': 'georgia',
  'german': 'germany',
  'ginnes': 'guinness',
  'gose': 'goose',
  'grade': 'grande',
  'grain': 'gran',
  'gran': 'grand',
  'grande': 'grand',
  'gray goose': 'grey goose',
  'greatfruit wine': 'grapefruit wine',
  'grips': 'gris',
  'guiness': 'guinness',
  'hammered': 'hammer',
  'heat': 'heart',
  'heiniken': 'heineken',
  'heneiken': 'heineken',
  'hermitage': 'heritage',
  'highball': 'hiball',
  'hineken': 'heineken',
  'hole': 'whole',
  'hors': 'horse',
  'iceland': 'ireland',
  'indian': 'india',
  'infusion': 'fusion',
  'ipe': 'ipa',
  'jack daniel': 'jack daniel’s',
  'jack daniels': 'jack daniel’s',
  'jamaican': 'jamaica',
  'jameison': 'jameson',
  'jamison': 'jameson',
  'jd': 'jack daniel’s',
  'jin': 'gin',
  'kaymus': 'caymus',
  'lager': 'lager',
  'larger': 'lager',
  'late': 'plate',
  'latte': 'late',
  'lamarc': 'la marca',
  'lamarca': 'la marca',
  'la marc': 'la marca',
  'leon': 'lemon',
  'lion': 'limon',
  'lite': 'liter',
  'liver': 'live',
  'luis': 'louis',
  'madeiro': 'madeira',
  'madrecuishe': 'madrecuixe',
  'madrecuixe': 'madrecuishe',
  'maestri': 'maestro',
  'malbeco': 'malbec',
  'mama': 'maman',
  'maman': 'mama',
  'marala': 'marsala',
  'marsla': 'marsala',
  'martin': 'martini',
  'masala': 'marsala',
  'medeira': 'madeira',
  'meritage': 'heritage',
  'merlot': 'merlot',
  'merlow': 'merlot',
  'merolt': 'merlot',
  'mexicano': 'mexico',
  'michel': 'michael',
  'michelle': 'michel',
  'michellob': 'michelob',
  'michelob': 'michel',
  'michelobe': 'michelob',
  'michlob': 'michelob',
  'mision': 'mission',
  'modella': 'modelo',
  'modleo': 'modelo',
  'moet': 'moët',
  'mont': 'monte',
  'more': 'amore',
  'moscoto': 'moscato',
  'moscotto': 'moscato',
  'negro': 'nero',
  'nuits': 'nuts',
  'order': 'border',
  'origin': 'original',
  'pain': 'plain',
  'pale ail': 'pale ale',
  'pape': 'paper',
  'pate': 'paste',
  'peach': 'each',
  'pearl': 'pear',
  'peppered': 'pepper',
  'petite': 'petit',
  'pickled': 'pickles',
  'pinnot grigio': 'pinot grigio',
  'pino noir': 'pinot noir',
  'pinot grigioo': 'pinot grigio',
  'pinot grisio': 'pinot grigio',
  'pinot noir': 'pinot noir',
  'pinot noirr': 'pinot noir',
  'pint': 'pinot',
  'planters': 'plates',
  'plated': 'plate',
  'point': 'pint',
  'portar': 'porter',
  'porto': 'port',
  'potatoes': 'potato',
  'preserve': 'reserve',
  'preserves': 'reserve',
  'price': 'rice',
  'puree': 'pure',
  'reisling': 'riesling',
  'regal': 'real',
  'reserva': 'reserve',
  'ret wine': 'red wine',
  'rieslng': 'riesling',
  'riserva': 'reserva',
  'rosado': 'reposado',
  'rosae': 'rosé',
  'rosay': 'rosé',
  'rose': 'rosé',
  'rosee': 'rosé',
  'rosey': 'rosé',
  'round': 'ground',
  'rrd wine': 'red wine',
  'rumms': 'rum',
  'sack': 'snack',
  'saki': 'sake',
  'savigon blanc': 'sauvignon blanc',
  'scotchh': 'scotch',
  'scoth': 'scotch',
  'seleccion': 'selection',
  'shine': 'shiner',
  'shotz': 'shot',
  'sigar': 'cigar',
  'sigarette': 'cigarette',
  'sigars': 'cigars',
  'sign': 'signa',
  'sipper': 'shipper',
  'sir davis': 'sirdavis',
  'slice': 'sliced',
  'smash': 'mash',
  'smoke': 'smoked',
  'smoothie': 'smooth',
  'sous': 'sours',
  'sparkeling wine': 'sparkling wine',
  'sparkiling wine': 'sparkling wine',
  'sparking wine': 'sparkling wine',
  'sparkline wine': 'white wine',
  'sparling wine': 'sparkling wine',
  'specials': 'especial',
  'specialty': 'special',
  'spice': 'spiced',
  'sport': 'port',
  'sprkling wine': 'sparkling wine',
  'state': 'estate',
  'staut': 'stout',
  'stelar': 'stella artois',
  'stella': 'stella artois',
  'stella artoise': 'stella artois',
  'stoppers': 'topper',
  'stripe': 'striped',
  'superior': 'superiore',
  'tabacco': 'tobacco',
  'tabaco': 'tobacco',
  'teqiula': 'tequila',
  'tequilla': 'tequila',
  'texans': 'texas',
  'thing': 'thin',
  'three': 'tree',
  'tito': 'tito’s',
  'titos': 'tito’s',
  'toasted': 'roasted',
  'tobaco': 'tobacco',
  'tobbaco': 'tobacco',
  'tomatoes': 'tomato',
  'topper': 'stopper',
  'tradicional': 'traditional',
  'tradition': 'traditional',
  'trail': 'tail',
  'urban': 'urbani',
  'valle': 'valley',
  'veu clicquot': 'veuve clicquot',
  'veuv': 'veuve clicquot',
  'veuve clicot': 'veuve clicquot',
  'vielle': 'vieilles',
  'vigne': 'vine',
  'vinho': 'vino',
  'virginia': 'virgin',
  'vista': 'vita',
  'vodak': 'vodka',
  'vodca': 'vodka',
  'vodcka': 'vodka',
  'vokka': 'vodka',
  'wglass': 'wglasses',
  'wglasses': 'glasses',
  'whandle': 'handle',
  'whhite wine': 'white wine',
  'whisky': 'whiskey',
  'whsikey': 'whiskey',
  'whskey': 'whiskey',
  'wine coole': 'wine cooler',
  'wine coolerd': 'wine cooler',
  'wine coolert': 'wine cooler',
  'wiskey': 'whiskey',
  'wite wine': 'white wine',
  'with wine': 'white wine',
  'wstraw': 'straw',
  'zinfendal': 'zinfandel',
  'zinfindel': 'zinfandel'
};
